import { HttpClient } from '../../protocols/http/httpClient'
import { IDeleteCustomRole } from '../../../domain/usecases/Roles'
import { throwIfHttpError } from '../../../validation/httpError'

export class RemoteDeleteCustomRole implements IDeleteCustomRole {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async delete(roleId: string): Promise<void> {
    const httpResponse = await this.httpClient.delete?.({
      url: `${this.url}/roles/custom/${roleId}`
    })
    throwIfHttpError(httpResponse, 'Erro ao excluir função')
  }
}
